import Async from "components/DesignSystem/AsyncComponents/Async";
import { SettingsAccordion } from "./SettingsAccordion";
import { SectionHeader, SettingRow } from "./BooksSettings";
import { Mail } from "components/icons/Mail";
import { Button } from "components/DesignSystem/Button/Button";
import { CopyIcon } from "components/icons/CopyIcon";
import { useGetInvoiceSettingsQuery } from "store/apis/invoices";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useToast } from "hooks/useToast";
import ToolTip from "components/design/toolTip";

export const BillsSettings = ({ entityId }: { entityId: string }) => {
  const group = useCurrentGroupContext();
  const { successToast } = useToast();
  const { data: invoiceSetting } = useGetInvoiceSettingsQuery(
    {
      groupId: group.uuid!,
      entityId,
    },
    { skip: !group.uuid || !entityId }
  );

  return (
    <Async.Root isLoading={false} isSuccess={true} isEmpty={false}>
      <Async.Success>
        <div className="t-pb-20">
          <SettingsAccordion.Root defaultValue={["BILL_FORWARDING"]}>
            <SettingsAccordion.Item value={"BILL_FORWARDING"}>
              <SettingsAccordion.Trigger>
                <SectionHeader
                  icon={<Mail className="t-size-3.5" />}
                  title={"Bill forwarding email"}
                />
              </SettingsAccordion.Trigger>

              <SettingsAccordion.Content>
                <SettingRow
                  description="Forward bills to your unique email address and we’ll automatically create a draft of your bill."
                  info={
                    <p className="t-text-body-sm-lite t-text-text-30 t-mb-0 t-w-[75%] sm:t-w-full">
                      You can review and mark it as active.
                    </p>
                  }
                >
                  <div className="t-flex t-justify-end t-items-center t-mr-1">
                    <ToolTip text="Click to copy">
                      <span>
                        <Button
                          customType="secondary"
                          size="small"
                          leftIcon={<CopyIcon className="t-text-text-30" />}
                          onClick={() => {
                            navigator.clipboard.writeText(
                              invoiceSetting?.bill_forwarding_email!
                            );
                            successToast({
                              title: "Email copied",
                              message:
                                "Bill forwarding email copied to clipboard",
                            });
                          }}
                        >
                          Bill forwarding email
                        </Button>
                      </span>
                    </ToolTip>
                  </div>
                </SettingRow>
              </SettingsAccordion.Content>
            </SettingsAccordion.Item>
          </SettingsAccordion.Root>
        </div>
      </Async.Success>
    </Async.Root>
  );
};
